import React from 'react'
// import { CardWithImage } from './OutComesSection'

const ProgramIncludedAndTrackerCards = ({ items = [], heading }) => {
    return (
        <div className='flex flex-col gap-8 
  ava-card-mukta
  p-6 ava-radius-md 
  w-full lg:flex-1 lg:max-w-[48%]'>
            <h2 className='ava-heading-md'> {heading}</h2>
            <div className='flex flex-col gap-6 w-full'>
                {items?.map((item) => (
                    <CardWithImage item={item}
                    />
                ))}
            </div>
        </div>
    )
}

export const CardWithImage = ({ item }) => {
  return (
    <div
      className="
        max-[425px]:w-full
        ava-card-bg ava-card-mukta
        ava-radius-md
        overflow-hidden
        items-center
        flex
        flex-col
        min-[425px]:flex-row
        transition-all duration-200 
      "
    >
      {/* IMAGE */}
      <div
        className="
          w-full
          h-[120px]
          min-[425px]:w-[40%]
          min-[768px]:w-[55%]
          flex-shrink-0
          overflow-hidden
        imageProg
        "
      >
        <img
          src={item.img}
          alt={item.title}
          className="w-full h-full object-cover"
          draggable={false}
        />
      </div>

      {/* CONTENT */}
      <div
        className="
          flex-1
          flex
          flex-col
          justify-center
          px-5
          py-4
          min-w-0
        "
      >
        <h3
          className="
            ava-text-subheading
           
          "
        >
          {item.title}
        </h3>

        {item?.desc && (
          <p className="mt-1 text-sm text-[var(--text-secondary)] leading-relaxed">
            {item.desc}
          </p>
        )}
      </div>
    </div>
  );
};





export default ProgramIncludedAndTrackerCards